













































import { Component, Vue, Config } from "@/common";
import { addRoleMenus } from "@/router";

@Component({})
export default class Login extends Vue {
  loginForm = {
    username: "",
    password: ""
  };
  loginRules = {
    username: [
      { required: true, trigger: "blur", validator: this.validateUsername }
    ],
    password: [
      { required: true, trigger: "blur", validator: this.validatePass }
    ]
  };
  loading: boolean = false;
  pwdType: string = "password";

  validateUsername(rule, value, callback) {
    if (value.length < 2) {
      callback(new Error(this.$t("login.accountNotLess2").toString()));
    } else {
      callback();
    }
  }
  validatePass(rule: any, value, callback) {
    if (value.length < 6) {
      callback(new Error(this.$t("login.passwordNotLess6").toString()));
    } else {
      callback();
    }
  }
  handleLogin() {
    (this.$refs.loginForm as any).validate(isValid => {
      if (isValid) {
        this.loading = true;
        this.$http
          .post("/Home/Login", {
            UserId: this.loginForm.username,
            Password: this.loginForm.password
          })
          .then(res => {
            if (res.data.status === 0) {
              this.$signalr.Init();
              this.$auth.setUser({
                userId: res.data.userId,
                tenantId: res.data.tenantId
              });
              addRoleMenus();
              this.$router.push({ path: "/Home" });
            } else {
              this.loading = false;
              this.$message.warning(res.data.msg);
            }
          })
          .catch(err => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    });
  }

  mounted() {
    window.document.title = this.$t("login.title").toString();
    this.$eventBus.on("signalr.reveive", notification => {
      console.log(notification);
    });
  }
}
